import css from '@emotion/css';
import theme from './theme';

const { fonts, colors } = theme;

const normalize = `
  *,::after,::before{box-sizing:border-box}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}hr{height:0}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:SFMono-Regular,Consolas,'Liberation Mono',Menlo,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{padding:0}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}
`;

const globalStyles = css`
  /* Normalize css styles */
  ${normalize}

  body {
    min-height: 100vh;
    font-family: ${fonts.Ubuntu};
    transition: color 0.1s ease-out, background 0.1s ease-out;
    min-height: 100vh;

    --bg: #fff;
    --main: ${colors.main};
    --secondary: ${colors.secondary};
    --darker: ${colors.darker};
    --cta: ${colors.cta};
    --cta2: ${colors.cta2};
    --error: ${colors.error};
    --info: ${colors.info};
    --msuccess: ${colors.msuccess};
    --warn: ${colors.warn};
    --text: ${colors.text};
    --blue: ${colors.blue};
    --darkerBlue: ${colors.darkerBlue};

    --hoverSuccess: ${colors.hoverSuccess};
    --success: ${colors.success};
    --darkSuccess: ${colors.darkSuccess};
    --darkText: ${colors.darkText};
    --darkWhite: ${colors.darkWhite};
    --deepBlue: ${colors.deepBlue};
    --border: ${colors.border};
    --pronouncedBorder: ${colors.pronouncedBorder};
    --textField: ${colors.textField};
    --shadow: ${colors.shadow};
    --darkButton: ${colors.darkButton};
    --badge: ${colors.badge};
    --card: ${colors.card};
    --gray: ${colors.gray};
  }

  body.dark {
    -webkit-font-smoothing: antialiased;
    background: #121212;
    --bg: #121212;
    --main: ${colors.dark.main};
    --secondary: ${colors.dark.secondary};
    --darker: ${colors.dark.darker};
    --cta: ${colors.dark.cta};
    --cta2: ${colors.dark.cta2};
    --error: ${colors.dark.error};
    --info: ${colors.dark.info};
    --msuccess: ${colors.dark.msuccess};
    --blue: ${colors.dark.blue};
    --darkerBlue: ${colors.dark.darkerBlue};

    --warn: ${colors.dark.warn};
    --text: ${colors.dark.text};
    --success: ${colors.dark.success};
    --hoverSuccess: ${colors.dark.hoverSuccess};
    --darkSuccess: ${colors.dark.darkSuccess};
    --darkText: ${colors.dark.darkText};
    --darkWhite: ${colors.dark.darkWhite};
    --deepBlue: ${colors.dark.deepBlue};
    --border: ${colors.dark.border};
    --pronouncedBorder: ${colors.dark.pronouncedBorder};
    --textField: ${colors.dark.textField};
    --shadow: ${colors.dark.shadow};
    --darkButton: ${colors.dark.darkButton};
    --badge: ${colors.dark.badge};
    --card: ${colors.dark.card};
    --gray: ${colors.dark.gray};

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      border: 1px solid lightblue;
      -webkit-text-fill-color: var(--text);
      -webkit-box-shadow: 0 0 0px 1000px #363636 inset;
      transition: background-color 5000s ease-in-out 0s;
    }

    .darkIcon {
      filter: invert(1);
    }
  }

  body::-webkit-scrollbar {
    width: 0.25rem;
  }

  body::-webkit-scrollbar-track {
    background: #1e1e24;
  }

  body::-webkit-scrollbar-thumb {
    background: #6649b8;
  }

  *:not(body)::-webkit-scrollbar {
    width: 0;
  }

  *:not(body)::-webkit-scrollbar-track {
    width: 0;
  }

  *:not(body)::-webkit-scrollbar-thumb {
    width: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.2;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    font-weight: 300;
    letter-spacing: 1px;
  }

  img {
    max-width: 100%;
  }

  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }

  input,
  button,
  select,
  optgroup,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  a:hover,
  a:focus,
  a:-webkit-any-link {
    text-decoration: none;
    outline: none;
  }

  ul,
  ol {
    padding: 0;
    margin: 0;
  }
`;

export default globalStyles;
